module.exports = __webpack_public_path__ + "img/MTCIECCM.4f1956b8.png";